import { render, staticRenderFns } from "./CalcTable.vue?vue&type=template&id=07c65968&scoped=true&"
import script from "./CalcTable.vue?vue&type=script&lang=js&"
export * from "./CalcTable.vue?vue&type=script&lang=js&"
import style0 from "./CalcTable.vue?vue&type=style&index=0&id=07c65968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c65968",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VSimpleTable,VTextField})
